// COCKPIT.FINAL.7 — contrat d'entrée pilote CANONIQUE (PURE, aucune I/O). Keyboard / Touch / Gamepad
// (et XR futur) produisent le MÊME PilotInputIntent normalisé. La conversion en vitesses (vx/vy/vz/
// yaw_rate) reste EXCLUSIVEMENT dans useRealOffboardControl + profils + limites Agent : AUCUN vx/vy/vz
// ici. NaN / Infinity / valeur invalide -> axe 0 (jamais propagé). deadman=false -> aucun axe non nul.

export const SOURCES = ["keyboard", "touch", "gamepad", "xr"];

// Clavier de vol -> direction (réutilise les directions existantes press/release de useRealOffboardControl).
export const KEY_DIR = {
  KeyW: "forward", ArrowUp: "forward", KeyS: "back", ArrowDown: "back",
  KeyA: "left", ArrowLeft: "left", KeyD: "right", ArrowRight: "right",
  KeyR: "up", KeyF: "down", KeyQ: "yaw_left", KeyE: "yaw_right",
};
// Clavier discret : hover / land / rtl (décollage et caméra traités ailleurs, hors de ce contrat).
export const KEY_DISCRETE = { Space: "hover", KeyL: "land", KeyH: "rtl" };

// direction -> contribution d'axe normalisée (observabilité / XR futur).
export const DIR_AXIS = {
  forward: ["pitch", 1], back: ["pitch", -1], right: ["roll", 1], left: ["roll", -1],
  up: ["lift", 1], down: ["lift", -1], yaw_right: ["yaw", 1], yaw_left: ["yaw", -1],
};

export function clampAxis(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return 0; // NaN / Infinity -> 0
  return Math.max(-1, Math.min(1, n));
}

// Normalise un intent brut d'une source. deadman par défaut true (maintien intentionnel) ; false explicite
// => tous les axes à 0. source invalide => valid=false et deadman neutralisé.
export function normalizeIntent(raw = {}, source = "keyboard", now = Date.now()) {
  const validSource = SOURCES.includes(source);
  const deadman = raw.deadman !== false && validSource;
  let pitch = clampAxis(raw.pitch), roll = clampAxis(raw.roll), lift = clampAxis(raw.lift), yaw = clampAxis(raw.yaw);
  if (!deadman) { pitch = 0; roll = 0; lift = 0; yaw = 0; }
  return {
    pitch, roll, lift, yaw,
    deadman,
    hover: !!raw.hover, land: !!raw.land, rtl: !!raw.rtl,
    speedUp: !!raw.speedUp, speedDown: !!raw.speedDown,
    source, timestamp: now, valid: validSource,
  };
}

export function hasContinuous(intent) {
  return !!intent && (intent.pitch !== 0 || intent.roll !== 0 || intent.lift !== 0 || intent.yaw !== 0);
}

// Arbitrage des AXES CONTINUS : un seul owner à la fois (évite clavier + gamepad + XR simultanés). PURE.
// active = la source a une intention continue valide (deadman). Aucune auto-reprise d'une ancienne source.
export function arbitrate(owner, source, active) {
  if (active) {
    if (owner === null || owner === undefined || owner === source) return source; // prend/garde la main
    return owner; // autre source active ignorée tant que l'owner tient
  }
  if (owner === source) return null; // retour neutre / perte -> libère l'owner
  return owner ?? null;
}
